const styles = (theme) => ({
  content: {
    padding: theme.spacing(3),
    height: '100%',
    overflow: 'auto'
  },
  newGridContent: {
    padding: '20px 30px',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      padding: '20px'
    }
  },
  addButton: {
    marginBottom: theme.spacing(2)
  },
  tableHeader: {
    '& thead tr th': {
      paddingTop: theme.spacing(1.5), // 12px
      paddingBottom: theme.spacing(1.5)
    }
  },
  breadcrumbLink: {
    color: theme.palette.colors.aquaDeep,
    fontWeight: 700,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  breadcrumbCurrent: {
    backgroundColor: theme.palette.colors.aquaDeep,
    color: 'white',
    padding: '4px 12px',
    borderRadius: '100px',
    fontWeight: 700
  },
  formPaper: {
    padding: theme.spacing(3)
  },
  uploadArea: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  uploadButton: {
    marginTop: theme.spacing(2)
  },
  submitButton: {
    marginTop: theme.spacing(2)
  },
  programListContainer: {
    height: '100%',
    marginTop: '-24px',
    '& > div': {
      backgroundColor: 'white'
    },
    '& .main-table': {
      minWidth: 1250
    }
  },
  tableCellStyles: {
    id: {
      padding: '20px 16px',
      minWidth: 200,
      overflowWrap: 'break-word'  // Add this
    },
    programName: {
      padding: '20px 16px',
      minWidth: 200,
      overflowWrap: 'break-word'  // Add this
    },
    deliveryMethod: {
      padding: '20px 16px',
      minWidth: 200,
      overflowWrap: 'break-word'  // Add this
    },
    updatedBy: {
      padding: '20px 16px',
      minWidth: 200,
      overflowWrap: 'break-word'  // Add this
    },
    updatedDate: {
      padding: '20px 16px',
      minWidth: 200,
      overflowWrap: 'break-word'  // Add this
    },
    actions: {
      padding: '20px 16px',
      minWidth: 200,
      overflowWrap: 'break-word'  // Add this
    }
  },
  gridContainer: {
    height: 600,
    '& .css-lzxddp td': {
      overflowWrap: 'anywhere !important',
      wordWrap: 'break-word !important',
      whiteSpace: 'normal !important',
    }
  },
});

export default styles;
